// This file is generated automatically by scripts/generate-icon.js. Don't modify it.

import AwardJapanStandard from '../_raw/award/icon_award_japan_standard.svg';
import withIconProps from '../withIconProps';

export default withIconProps(AwardJapanStandard, { shouldSetDefaultSize: false });
